import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type FloorStoreState
 */
const initialState = {
  salutationList: { loading: false, data: null, error: null },
};

export const SalutationSlice = createSlice({
  name: "salutation",
  initialState,
  reducers: {
    fetchsSalutationListRequest: (state, action) => {
      state.salutationList.loading = true;
      state.salutationList.error = null;
    },
    fetchsSalutationListSuccess: (state, action) => {
      state.salutationList.data = action.payload;
      state.salutationList.loading = false;
      state.salutationList.error = null;
    },
    fetchsSalutationListFailure: (state, action) => {
      state.salutationList.data = null;
      state.salutationList.loading = false;
      state.salutationList.error = action.payload;
    },
  },
});

export const {
  fetchsSalutationListRequest,
  fetchsSalutationListSuccess,
  fetchsSalutationListFailure,
} = SalutationSlice.actions;

/**
 *
 * @param {*} store
 * @returns {FloorStoreState['floorList']}
 */
export const getSalutationListState = (store) =>
  store.salutation?.salutationList;

export default SalutationSlice.reducer;
